import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('IS.FM.AccessMgmt.AccessMgmtPageHeader'),
      "subtitle": _vm.$i18n_t('IS.FM.AccessMgmt.AccessMgmtPageHeaderInfoText')
    }
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('IS.FM.AccessMgmt.AccMgmtTableHeader'),
      "buttons": _vm.buttons
    },
    on: {
      "addItem": _vm.addItem
    }
  }, [_c(VRow, {
    staticStyle: {
      "width": "100%"
    }
  }, [_c(VCol, {
    staticClass: "pt-6 pb-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.$i18n_t('IS.FM.AccessMgmt.AccMgmtTableInfo')) + "\n            ")])]), _c(VCol, {
    staticClass: "pt-0 pb-0",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "cols": "6"
    }
  }, [_vm.items.length > 0 ? _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "append-icon": "fal fa-search",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "single-line": "",
      "clearable": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }) : _vm._e()], 1)], 1), _c(VSpacer), _c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "800px",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_vm.dialog ? _c('is-fm-accmgmtrowdetail', {
    attrs: {
      "editedItem": _vm.editedItem
    },
    on: {
      "close": _vm.close,
      "save": _vm.save
    }
  }) : _vm._e()], 1), _c(VCardText, {
    staticClass: "pr-0 pl-0"
  }, [_c(VDataTable, {
    attrs: {
      "headers": _vm.tableLocalizations.headers,
      "items": _vm.items,
      "search": _vm.search,
      "loading": _vm.tableLoading,
      "color": _vm.color,
      "footer-props": _vm.tableLocalizations.footerProps,
      "item-key": "id",
      "page": _vm.tableOptions.page,
      "options": _vm.tableOptions
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      },
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [_c('tr', [_c('td', [_c(VIcon, {
          class: _vm.color + '--text'
        }, [_vm._v("fal fa-key")])], 1), _c('td', [_vm._v(_vm._s(props.item.id))]), _c('td', {
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "200px"
          }
        }, [_vm._v("\n                  " + _vm._s(props.item.user.firstName) + "\n                ")]), _c('td', {
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "200px"
          }
        }, [_vm._v("\n                  " + _vm._s(props.item.user.lastName) + "\n                ")]), _c('td', [_vm._v(_vm._s(props.item.user.email))]), _c('td', [_vm._v(_vm._s(_vm.keyTwinTitle(props.item)))]), _c('td', [_vm._v(_vm._s(props.item.accessObjectData.title))]), _c('td', {
          staticClass: "text-center"
        }, _vm._l(props.item.icons, function (icon) {
          return _c(VTooltip, {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: props.item.icons.length,
              expression: "props.item.icons.length"
            }],
            key: icon.icon,
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function ({
                on
              }) {
                return [_c(VIcon, _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "color": _vm.color,
                    "small": ""
                  }
                }, on), [_vm._v(_vm._s(icon.icon))])];
              }
            }], null, true)
          }, [_c('span', [_vm._v(_vm._s(icon.tooltip))])]);
        }), 1), _c('td', {
          staticClass: "text-right"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.editItem(props.item);
            }
          }
        }, [_vm._v("\n                    fal fa-edit\n                  ")]), _vm._v("\n                   \n                  "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.deleteItem(props.item);
            }
          }
        }, [_vm._v("\n                    fal fa-trash-alt\n                  ")])], 1)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (props) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                  " + _vm._s(props.pageStart) + "-" + _vm._s(props.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(props.itemsLength) + "\n                ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": props.itemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n              ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };